import {CompanyUserRegistrationTypeEnum} from "../models/company";
import {environment} from "../../environments/environment";

export const ALERT_TYPE_DATE_RANGE_SELECTION = "Please select a valid Date range to generate the report."
export const HOME_PATH = "";
export const LOGIN_PATH = "/login";
export const USERS_PATH = "/users";
export const AGENCY_PATH = "/agencies";
export const NOT_ALLOWED = "/not-allowed";
export const CHANGE_PASSWORD_PATH = "/change-password";
export const TWOFA_VERIFICATION_PATH = "/2fa-verification";
export const TOTP_SETUP_PATH = "/totp-setup";
export const VERIFICATION_PATH = "/verification";
export const DASHBOARD_PATH = "/dashboard";
export const SUBMISSION_PATH = "/visits";
export const FORCE_RESET_PASSWORD_PATH = "/force-reset-password";
export const USER_LISTING_PATH = "/users";
export const IOH_USER_PATH = "/ioh-users";
export const VISIT_PATH = "visits";
export const EDOCS = "/e-docs";
export const EPISODE_PATH = "/episodes";
export const PVISITS = "/p-visits";
export const SUPPORT_TICKET = "/support-ticket";
export const UNMATCHED_VISITS = "/unmatched-visits";
export const TOKEN_KEY = "_token";
// Amplify 5 sets this in localStorage after a Hosted UI sign-in; Auth.signOut() then takes the Hosted UI redirect.
// Tied to Amplify's internals: re-check on an Amplify upgrade.
export const HOSTED_UI_SIGN_IN_FLAG = "amplify-signin-with-hostedUI";
export const NEW_PASSWORD_REQUIRED = "NEW_PASSWORD_REQUIRED";
export const NEW_PASSWORD_REQUEST_SEND = "NEW_PASSWORD_REQUEST_SEND";
export const USER_VERIFIED = "USER_VERIFIED";
export const USER_PROFILE = "Profile";
export const CREATE_NEW_PASSWORD = "/create-new-password";
export const FORGOT_PASSWORD = "/forgot-password";
export const PASSWORD_RESET_DONE = "/password-reset-done";
export const SUPER_ADMIN = "Super Admin";
export const IOH_ADMIN = "IOH Admin";
export const COMPANY_ADMIN = "Company Admin";
export const dateFormat = "MM-dd-yyyy";
export const dateFormatStartWithYear = "yyyy-MM-dd";
export const dateFormatStartWithYearWithOutDashes = "yyyyMMdd";
export const DATE_PICKER_FORMAT = "mm-dd-yy";
export const DATE_PICKER_PLACEHOLDER = "mm-dd-yy - mm-dd-yy";
export const dateAndTimeFormat = "MM-dd-yyyy hh:mm a";
export const reportDateAndTimeFormat = 'MMM d, y, h:mm:ss a';
export const LOGO_TEXT = "Real-time chart validation for home health agencies.";
export const EXPIRED_PASSWORD_TEXT = "Security alert: You have not changed your password since 60 days.";
export const FOOTER_TEXT = "© " + new Date().getFullYear() + " io Health Tech, All Rights Reserved.";
export const REFRESH_TOKEN_INTERVAL = 5 * 60 * 1000 - 5000;
// Cognito App Client token validity for the active environment (per environment.*.ts,
// matching AWS Console -> Cognito -> User Pools -> App clients -> token expiration settings).
// Used to preemptively log the user out once the refresh token is known to be expired,
// instead of sending it to Cognito's REFRESH_TOKEN_AUTH flow to find out (IOHB-NA).
export const ACCESS_TOKEN_EXPIRY_MS = environment.cognito.accessTokenExpiryMinutes * 60 * 1000;
export const REFRESH_TOKEN_EXPIRY_MS = environment.cognito.refreshTokenExpiryMinutes * 60 * 1000;
export const VERIFICATION_CODE_EXPIRED_MESSAGE = "Your Verification Code has been Expired.";
export const DEFAULT_REPORT_DOWNLOAD_LOCKED_MESSAGE = "Sorry, you cannot download the report at the moment due to multiple failed attempts. Access is locked for one hour.";
export const PHONE_NUMBER_LENGTH = 10;
export const PHONE_NUMBER_REGEX = "^\\d{10}$";
// One or more alphanumeric branch codes separated by commas with no spaces, e.g. "GHH" or "GHH,MTM".
export const BRANCH_CODES_PATTERN = /^[A-Za-z0-9]+(,[A-Za-z0-9]+)*$/;
export const DOB_DATE_FORMAT = "mm/dd/yy";
export const ePH_LINK_SEND = "The PH Link request has been sent successfully";
export const DOB_NOT_MATCH = "The DOB  provided does not match. Please try again.";
export const DOB_MATCH = "The DOB provided has been matched successfully.";
export const FILE_DOWNLOAD_SUCCESS = "File downloaded successfully.";
export const US_TIME_ZONE = "locale";
export const REPORT_TIME_ZONE = "America/New_York";
export const IMPACT = "impact";
export const SEARCH_PATIENT_BY_NAME_OR_MRN = "Search by first/last name or mrn";
export const SEARCH_PATIENT_BY_ID = "Search by Id";
export const SEARCH_PATIENT_BY_CASE_MANAGER = "Search by case manager";
export const SEARCH_PATIENT_BY_CASE_CLINICIAN = "Search by clinician name";
export const SEARCH_PATIENT_BY_MRN = "Search by first/last name or mrn";
export const SEARCH_UNMATCHED_VISIT_BY_ID = "Search unmatched visit by ID";
export const TEMP_PASSWORD_EXPIRED = "Password reset Email has been sent.";
export const DEFAULT_USER_IMAGE = "assets/images/Subtract.svg";
export const USER_NOT_ACTIVE = "Your account has been deactivated,\n To reactivate it, please contact your account administrator.";
export const SESSION_EXPIRED_MESSAGE = "Your session has expired. Please log in again.";
export const USER_DELETED = "Your account has been deleted.";
export const NO_USER_FOUND = "User not authorized";
export const NO_AUTHORIZE_USER = "User not authorized!";
export const SSO_SIGN_IN_FAILED = "Sign-in with SSO did not complete. Please try again.";
export const BULK_USER_UPLOAD = "Bulk Users Uploaded successfully";
export const BULK_USER_UPLOAD_FAILED = "Bulk Users Upload failed";
export const BULK_USER_UPLOAD_FAILED_MESSAGE = "Please verify the agency name and try again";
export const BULK_USER_UPLOAD_ALLOWED_FORMAT = "text/csv";
export const BULK_USER_UPLOAD_FILE_FORMAT_ERROR = "The file format should be csv";
export const ALLOWED_SOC_PACKET_FILE_FORMATS = ['application/pdf'];
export const SOC_PACKET_FILE_FORMAT_ERROR = "Invalid file type. Please upload a PDF file.";
export const BULK_PATIENT_UPLOAD = "Bulk Patients Uploaded successfully";
export const BULK_PATIENT_UPLOAD_FAILED_MESSAGE = "Please verify the file and try again";
export const BULK_PATIENT_UPLOAD_ALLOWED_FORMATS = [
  "text/csv",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // xlsx
];
export const BULK_PATIENT_UPLOAD_FILE_FORMAT_ERROR = "The file format should be csv or xlsx";
export const COORDINATION_NOTE_UPLOAD_SUCCESS = "Coordination Note uploaded successfully";
export const COORDINATION_NOTE_UPLOAD_FAILED_MESSAGE = "Please verify the file and try again";
export const COORDINATION_NOTE_UPLOAD_ALLOWED_FORMATS = [
  "text/csv",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // xlsx
];
export const COORDINATION_NOTE_UPLOAD_FILE_FORMAT_ERROR = "The file format should be csv or xlsx";

// Medication Alerts Batch Upload - shared messages when backend and display text are identical (declare once, reuse)
const MSG_MEDICATION_NAME_EXISTS = "Some Medication Name alerts already exist for this agency";
const MSG_MEDICATION_IDENTIFIER_EXISTS = "Medication alert with this identifier already exists for this agency";
const MSG_INVALID_FILE_HEADER = "Invalid file header. Please use the provided template.";
const MSG_NO_DATA_FOUND = "No data found in file to upload.";

// Mapped messages align with medication-alert batch upload backend messages.
export const MEDICATION_ALERTS_BATCH_UPLOAD = {
  allowedFormats: [
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-excel",
    "text/csv",
  ],
  messages: {
    fileFormatError: "Invalid file type. Allowed: .xlsx, .csv",
    success: "Medication alerts batch upload completed successfully.",
    failed: "Medication alerts batch upload failed.",
  },
  // Backend error pattern -> display message. Use `message` only when match and display are the same.
  errorMappings: [
    { message: MSG_MEDICATION_NAME_EXISTS },
    { pattern: "Invalid file type.", andContains: "Allowed", message: "Invalid file type. Allowed: .xlsx, .csv" },
    { pattern: MSG_NO_DATA_FOUND, andContains: "no data rows", message: `${MSG_NO_DATA_FOUND} The file has no data rows.` },
    { pattern: MSG_NO_DATA_FOUND, andContains: "empty or invalid", message: `${MSG_NO_DATA_FOUND} All rows are empty or invalid.` },
    { message: MSG_INVALID_FILE_HEADER },
    { message: MSG_MEDICATION_IDENTIFIER_EXISTS },
    { message: "File is required" },
    { pattern: "File exceeds maximum allowed size", message: "File exceeds maximum allowed size (5 MB)." },
  ],
} as const;

/** Max file size for medication library batch upload (5 MB). */
export const MEDICATION_ALERT_BATCH_MAX_FILE_SIZE_BYTES = 5 * 1024 * 1024;

export const CSV_MIME_TYPE = "text/csv;charset=utf-8;";
export const BULK_USER_UPLOAD_FILE_SIZE = "File size should be less than 5MB";

// Layout JSON Upload Constants
export const LAYOUT_JSON_UPLOAD_LIMIT = 10; // Default limit for number of layouts to load from JSON
export const LAYOUT_JSON_FILE_TYPE = 'application/json';
export const LAYOUT_JSON_FILE_EXTENSION = '.json';
export const LAYOUT_JSON_INVALID_FILE_TYPE = "Please upload a .json file only";
export const LAYOUT_JSON_INVALID_FORMAT = "Invalid JSON file. Please check the file format";
export const LAYOUT_JSON_EMPTY = "JSON file is empty";
export const LAYOUT_JSON_NO_LAYOUTS = "JSON file does not contain any layouts";

export const RULES_JSON_UPLOAD_LIMIT = 50;
export const RULES_JSON_INVALID_FILE_TYPE = "Please upload a .json file only";
export const RULES_JSON_INVALID_FORMAT = "Invalid JSON file. Please check the file format";
export const RULES_JSON_EMPTY = "JSON file is empty";
export const RULES_JSON_NO_RULES = "JSON file does not contain any rules";

export const USER_NOT_FOUND = "Incorrect username or password.";
export const EMAIL_SENT_IF_USER_EXISTS = "If the user exists, an email has been sent to the email provided";
export const USER_ACCOUNT_ALREADY_EXIST = "An account with the given email already exists.";
export const DEFAULT_MRN_LENGTH = 16;
export const DEFAULT_UNMATCHED_MRN_LENGTH = 16;
export const DEFAULT_PATIENT_ID_LENGTH = 20;
export const DEFAULT_PATIENT_NAME_LENGTH = 17;
export const DEFAULT_CASE_MANAGER_NAME_LENGTH = 20;
export const DEFAULT_ROLE_NAME_LENGTH = 23;
export const DEFAULT_SEARCH_MIN_CHARACTER = 2;
export const DEFAULT_AGENCY_EDOC_LINK_EXPIRATION_TIME = 28;
export const DEFAULT_ORDER_BY_PATIENT_VISIT = "submissionDate";
export const DEFAULT_ORDER_PATIENT_VISIT = "-1";
export const PATH_BEFORE_REFRESH = "pathBeforeRefresh";
export const CURRENT_RELEASE_VERSION = "V26.11.2";
export const RELOAD_PAGE_AFTER_RELEASE = 5000;
export const DEBOUNCE_TIME_SET = 2000;
export const USER_ACTIVITY_HOURS_IN_PAST = 72;
export const DEFAULT_ORG_ID_ROTATION_DAYS = 30;
export const DEFAULT_DAYS_TO_DELETE_REPORT = 30;
export const EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
export const EXCEL_EXTENSION = ".xlsx";
export const AGENCY_REPORT_FILE_NAME = "AgencyReport-";
export const USER_DEVICES_REPORT_FILE_NAME = "Devices";
export const USER_STATUS_REPORT_FILE_NAME = "User Status-";
export const USER_STATUS_REPORT_FILE_TITLE = "User Status";
export const ERROR_WARNING_REPORT_FILE_NAME = "Errors and Warnings Report";
export const EDOC_REPORT = "ioDoc";
export const USER_STATUS_FILE_NAME = "User Status";
export const UTILIZATION_REPORT_FILE_NAME = "Utilization";
export const PASSWORD_STRENGTH_VALIDATION_MESSAGE = "Min 8 characters with a combination of letters,numbers and one special character.";
export const PASSWORD_STRENGTH_STRONG = "Strong";
export const PASSWORD_STRENGTH_STRONG_CLASS = "strong-password";
export const PASSWORD_STRENGTH_MEDIUM = "Medium";
export const PASSWORD_STRENGTH_MEDIUM_CLASS = "medium-password";
export const PASSWORD_STRENGTH_WEAK = "Weak";
export const PASSWORD_STRENGTH_WEAK_CLASS = "weak-password";
export const INVALID_PASSWORD = "Invalid";
export const INVALID_PASSWORD_CLASS = "invalid-password";
export const SUBJECTIVE_DEFAULT_VALUE = "subjective";
export const SUBJECTIVE_OTHER_DEFAULT_VALUE = "others";
export const SUBJECTIVE_X11_DEFAULT_VALUE = "xx11";

export const DEFAULT_VISIT_DATE_FILTER = 7;
export const DEFAULT_PATIENT_DATE_FILTER = 7;
export const DEFAULT_EPISODE_DATE_FILTER = 7;

export const CHANGE_USER_PASSWORD_DAYS = 60;
export const CHANGE_USER_PASSWORD_BANNER_SHOW_DAYS = 53;

export const PASSWORDS_MUST_MATCH = "Password and confirm password must be same.";

export const RESET_PASSWORD_FIELDS_MISSING = "Please fill out all fields to set your password.";
export const RESET_PASSWORDS_NOT_MATCHING = "Passwords do not match! Please click the eye icon to double check.";
export const RESET_PASSWORDS_NOT_LONG_ENOUGH = "The password you created is too easy, please create a more complex password to keep data safe!";
export const EMAIL_ALREADY_REGISTERED_USER = "The email address you have provided is already registered with another User.";
export const EMAIL_ALREADY_REGISTERED_COMPANY = "The email address you have provided is already registered with another Company.";
export const EMAIL_ALREADY_REGISTERED_AGENCY = "The email address you have provided is already registered with another Agency.";
export const FORBIDDEN = "Forbidden: ";
export const FORBIDDEN_MESSAGE = "Sorry, The file has been removed OR expired.";
export const FILE_NOT_OPENED = "Not Opened";

export const ANONYMOUS = "anonymous";
export const QUESTIONAIR_TYPE_WARN = "Warn";
export const QUESTIONAIR_TYPE_WARNING = "Warning";
export const QUESTIONAIR_TYPE_ERROR = "Error";
export const CLINICIAN_CHANGE_REPORT_NAME = "Clinician Change";
export const CLINICIAN_SUGGESTION_CALCULATION_REPORT_NAME = "The suggestion calculator report";
export const REGISTRATION_ACTIVATED_STATUS = "Activated";
export const REGISTRATION_WAITING_STATUS = "Waiting";
export const ACTIVATION_EMAIL_SUCCESS_MESSAGE = "Activation email sent successfully";
export const IO_ALERT_REPORT_NAME = "QA Assist Report"

export const NO_OF_RECORDS_PER_PAGE = 30;

export enum FileType {
  file = "file",
  piReportFile = "piReportFile",
  otherFile = "otherFile",
  hosAddendum = "hosAddendum",
}

export enum FileTypeNames {
  file = "PH Report",
  piReportFile = "PIReport",
  otherFile = "Other Report",
}

export enum FileTypeHistory {
  ePH = "PH File",
  piReport = "PIReport File",
  other = "Other File",
}

export enum NewFileUploadType {
  file = "PH File",
  piReportFile = "PIReport File",
  otherFile = "Other File",
}

export enum DeletedFileType {
  file = "ePH",
  piReportFile = "piReport",
  otherFile = "other",
}

export enum RoleID {
  Admin = "SUPER_ADMIN",
  iohAdmin = "IOH_ADMIN",
  companyAdmin = "COMPANY_ADMIN",
  AgencyAdmin = "AGENCY_ADMINISTRATOR",
  IOHAgencyAdmin = "IOH_AGENCY_ADMINISTRATOR",
  CaseManager = "CASE_MANAGER",
  PatientManager = "PATIENT_MANAGER",
  Clinician = "CLINICIAN",
  OfficeWorker = "OFFICE_WORKER",
}

export const RoleNames = {
  SUPER_ADMIN: "Super Admin",
  IOH_ADMIN: "IOH Admin",
  COMPANY_ADMIN: "Company Admin",
  AGENCY_ADMINISTRATOR: "Agency Admin",
  // IOH_AGENCY_ADMINISTRATOR: "IOH Agency Admin",
  CASE_MANAGER: "Case Manager",
  CLINICIAN: "Clinician",
  OFFICE_WORKER: "Office Worker",
};

export const MfaAllowedRoles = [
  RoleID.Admin.toString(),
  RoleID.iohAdmin.toString(),
  RoleID.companyAdmin.toString(),
  RoleID.AgencyAdmin.toString(),
  RoleID.IOHAgencyAdmin.toString(),
  RoleID.CaseManager.toString(),
];
export enum HideMrnForUsers {
  SUPER_ADMIN = "SUPER_ADMIN",
  IOH_ADMIN = "IOH_ADMIN",
  COMPANY_ADMIN = "COMPANY_ADMIN",
  IOH_AGENCY_ADMINISTRATOR = "IOH_AGENCY_ADMINISTRATOR",
}
export const AllExceptPatientAllowedRoles = [
  RoleID.Admin.toString(),
  RoleID.iohAdmin.toString(),
  RoleID.companyAdmin.toString(),
  RoleID.AgencyAdmin.toString(),
  RoleID.CaseManager.toString(),
  RoleID.OfficeWorker.toString(),
  RoleID.PatientManager.toString(),
  RoleID.Clinician.toString(),
];
export const adminRoles = [
  RoleID.Admin.toString(),
  RoleID.iohAdmin.toString(),
  RoleID.IOHAgencyAdmin.toString(),
  //RoleID.companyAdmin.toString(),
];
export const superAdminRoles = [
  RoleID.Admin.toString(),
  RoleID.iohAdmin.toString(),
  RoleID.IOHAgencyAdmin.toString(),
  RoleID.companyAdmin.toString(),
];
export const OnlyAdminAllowedRoles = [
  RoleID.Admin.toString(),
  RoleID.iohAdmin.toString(),
  RoleID.AgencyAdmin.toString(),
  RoleID.companyAdmin.toString(),
];
export const OnlySuperAdminAllowedRoles = [
  RoleID.Admin.toString(),
  RoleID.iohAdmin.toString()
];
export const OnlyIOHSuperAdminAllowedRoles = [RoleID.Admin.toString()];
export const OnlyAdminAndCompanyAdminAllowedRoles = [RoleID.Admin.toString(), RoleID.iohAdmin.toString(), RoleID.companyAdmin.toString()];

/**
 * Roles allowed to access the E-Sign feature (send, view history, manage templates).
 * Patient-facing endpoints (verify DOB, sign document) are publicly accessible via token.
 */
export const EsignAllowedRoles = [
  RoleID.Admin.toString(),          // Super Admin
  RoleID.iohAdmin.toString(),       // IO Admin
  RoleID.companyAdmin.toString(),   // Company Admin
  RoleID.AgencyAdmin.toString(),    // Agency Admin
  // RoleID.IOHAgencyAdmin.toString(), // IOH Agency Admin (variant of Agency Admin)
];

export const OPT_IN = "Opt In";
export const OPT_OUT = "Opt Out";

export const OnlyAllowedExceptClinicianRoles = [
  RoleID.Admin.toString(),
  RoleID.iohAdmin.toString(),
  RoleID.companyAdmin.toString(),
  RoleID.AgencyAdmin.toString(),
  RoleID.CaseManager.toString(),
  RoleID.OfficeWorker.toString(),
];
export const superAndCaseMangerRoles = [
  RoleID.Admin.toString(),
  RoleID.iohAdmin.toString(),
  RoleID.companyAdmin.toString(),
  RoleID.AgencyAdmin.toString(),
  RoleID.CaseManager.toString()
];
export const OnlyClinicianAllowedRoles = [
  RoleID.Admin.toString(),
  RoleID.iohAdmin.toString(),
  RoleID.companyAdmin.toString(),
  RoleID.AgencyAdmin.toString(),
  RoleID.CaseManager.toString(),
  RoleID.OfficeWorker.toString(),
  RoleID.Clinician.toString(),
];

export const appSettings = {
  showOK: true,
  showWarnError: false,
  highlightCircle: true,
  highlightSrect: false,
  highlightLrect: false,
  toastPopUp: false,
  crossRulesEnabled: false,
  crossRulesA2VsA1Enabled: false,
  dcVsSocRulesEnabled: false,
  webCrossRulesEnabled: false,
  webCrossRulesA2VsA1Enabled: false,
  webDcVsSocRulesEnabled: false,
  minBuildVersion: false,
  batteryOpPermission: false,
  readNotify: true,
  mlRules: false,
  hideIOHealthFloatingMenu: false,
  showCareCompass: false,
  disablePreQACheck: CompanyUserRegistrationTypeEnum.Disabled,
  disableSurveyGuide: CompanyUserRegistrationTypeEnum.Disabled,
  enableChartPull: CompanyUserRegistrationTypeEnum.NotSet
};

export const appSettingsCheckbox = [
  { label: "Minimum build version", value: "minBuildVersion" },
  { label: "Show Warning and Error", value: "showWarnError" },
  { label: "Show OK", value: "showOK" },
  { label: "Highlight Small Rectangle", value: "highlightSrect" },
  { label: "Highlight Circle", value: "highlightCircle" },
  { label: "Highlight Large Rectangle", value: "highlightLrect" },
  { label: "Cross Matrix Rules", value: "crossRulesEnabled" },
  { label: "Show Toast Popup", value: "toastPopUp" },
  { label: "DC vs SOC Rules (including A3 vs A1)", value: "dcVsSocRulesEnabled" },
  { label: "Web GG 1 & 2 Rules", value: "webCrossRulesA2VsA1Enabled" },
  { label: "GG 1 & 2 Rules", value: "crossRulesA2VsA1Enabled" },
  { label: "Web Cross Matrix Rules", value: "webCrossRulesEnabled" },
  { label: "Web DC vs SOC Rules (including A3 vs A1)", value: "webDcVsSocRulesEnabled" },
  { label: "Battery Op Permission", value: "batteryOpPermission" },
  { label: "Read Notify", value: "readNotify" },
  { label: "DL Rules", value: "mlRules" },
  { label: "Hide IOHealth Floating Menu", value: "hideIOHealthFloatingMenu" },
  { label: "Care Compass", value: "showCareCompass" },
];

export const allowToUpdateVisitsRoles = [RoleID.companyAdmin.toString(), RoleID.AgencyAdmin.toString(), RoleID.CaseManager.toString()];

export const OnlyCaseManagerClinicianAllowedRoles = [RoleID.CaseManager.toString(), RoleID.OfficeWorker.toString(), RoleID.Clinician.toString()];
export const portalFeatureValues = [
  { name: "eDoc", label: "ioDoc", value: false },
  { name: "qaScrubberEnabled", label: "ioIQ", value: false },
  // Super Admins only for now. To open it to IOH Admins, drop superAdminOnly here and take it off
  // SUPER_ADMIN_ONLY_FEATURES in the user service, which otherwise ignores their change.
  { name: "qaScrubberV4Enabled", label: "ioIQ v4.1", value: false, superAdminOnly: true },
];
export const portalFeatureValuesForCompany = [
  { name: "qaScrubberEnabled", label: "ioIQ", value: false },
  // Super Admins only for now. To open it to IOH Admins, drop superAdminOnly here and take it off
  // SUPER_ADMIN_ONLY_FEATURES in the user service, which otherwise ignores their change.
  { name: "qaScrubberV4Enabled", label: "ioIQ v4.1", value: false, superAdminOnly: true },
  { name: "logShipEnabled", label: "Log Ship", value: false },
  // Which assessment forms this company's LogShip feed carries. Leave both unticked when it carries
  // both, which is most companies; tick one when it only carries that one. The Admin Dashboard's
  // Logship tab (cds logship-status) uses this to grey out forms a company never receives.
  { name: "logShipOasisForms", label: "Log Ship: OASIS forms", value: false },
  { name: "logShipHopeForms", label: "Log Ship: HOPE forms", value: false },
  { name: "ioDocAutofillEnabled", label: "ioDoc Autofill", value: false },
  { name: "hosAddendumEnabled", label: "HOS Addendum", value: false }
];
export const rowsPerPageOptions = [10, 20, 30];
export const SPINNER_ICON = "https://icon-library.com/images/spinner-icon-gif/spinner-icon-gif-24.jpg";

// This group mapping will be change or get expanded over-time
export const ERROR_WARNING_DIAGNOSTIC_GROUP_MAPPING = [
  {
    group_values: ["Joint Replacement - Knee or Hip", "MZ41.1", "ortho-knee hip"],
    group_name: "MS-Rehab - Joint Replacement",
  },
  {
    group_values: ["S42.291D", "S83.232D", "M75.102", "M75.11", "Other orthopedic rehab"],
    group_name: "MS-Rehab - Other",
  },
  {
    group_values: ["ortho-spine"],
    group_name: "MS-Rehab - Spine",
  },
  {
    group_values: ["Cardiac"],
    group_name: "MMTA - Cardiac",
  },
  {
    group_values: ["Other", "default"],
    group_name: "Other",
  },
  {
    group_values: ["Wound Care"],
    group_name: "Wound",
  },
  {
    group_values: [],
    group_name: "NEURO_REHAB",
  },
  {
    group_values: [],
    group_name: "Complex",
  },
];

export const ANSWER_MAPPING = {
  "-1": "Not Assessed / No Information",
  "-2": "Unknown",
  "-3": "Not Applicable",
};

export const ERROR_MESSAGES = {
  USER_PROFILE_FETCH: 'Error fetching user profile',
  USER_PROFILE_SETUP: 'Error in user profile setup',
  FETCH_AGENCIES: 'Error fetching agencies',
  FORM_DATA_LOAD: 'Error loading form data',
  COMMUNICATION: 'Communication error: ',
  COMPANY_NOT_FOUND: 'Company not found',
  INVALID_FORM_LIST: 'Invalid form list data',
  INVALID_FORM_ITEM: 'Invalid form list item',
  NO_ROW_DATA: 'No row data provided',
  INITIALIZE_AGENCY_FILTER: 'Error initializing agency filter',
  CREATE_UPDATE_FORM: (isEdit: boolean) =>
    `Error ${isEdit ? 'updating' : 'creating'} form data`,
  SUCCESS_CREATE_UPDATE: (isEdit: boolean) =>
    `Form data ${isEdit ? 'updated' : 'created'} successfully`,
  CONFIRM_COMPANY_SELECT: {
    MESSAGE: 'Please confirm if you wanted to select this Company',
    HEADER: 'Confirm Company?',
    ACCEPT: 'Confirm',
    REJECT: 'Cancel',
  },
  CONFIRM_COMPANY_DELETE: {
    MESSAGE: 'Please confirm if you wanted to delete this Company',
    HEADER: 'Delete Company?',
    ACCEPT: 'Delete',
    REJECT: 'Cancel',
  },
  TOOLTIP_GENERATION_ERROR: 'Error generating tooltip:',
  CONFIRM_QUESTION_DELETE: {
    MESSAGE: 'Are you sure you want to delete this question?',
    HEADER: 'Delete Confirmation',
    ACCEPT: 'Delete',
    REJECT: 'Cancel',
  },
  QUESTION_DELETE_SUCCESS: 'Question deleted successfully',
  QUESTION_DELETE_FAILED: 'Failed to delete question',
  DUPLICATE_QUESTION_HEADER: 'Duplicate Question',
} as const;

// Title Constants
export const DEFAULT_TITLE = 'IOHealth Portal';
export const AUTHENTICATED_TITLE = 'Welcome to IOHealth';

export const REPROCESS_SUCCESS_MESSAGE = "Visit reprocessed successfully";
export const REPROCESS_ERROR_MESSAGE = "Failed to reprocess visit";

export const REPORT_DELETED_ERROR_MESSAGE = "Failed to delete report";
export const APK_DATA_DELETED_SUCCESS = "APK data deleted successfully";

// Toast Message Types
export const TOAST_SUCCESS = "success";
export const TOAST_ERROR = "error";
export const TOAST_WARN = "warn";

// Toast Message Titles
export const TOAST_ERROR_TITLE = "Error";

// QA Notes Messages
export const QA_NOTE_SAVED_SUCCESS = "QA note saved successfully";
export const QA_NOTE_SAVE_ERROR = "Failed to save QA note";

// CSV Export Messages
export const CSV_EXPORT_NO_ROWS_SELECTED_MESSAGE = "Please select at least one row to export";

/** IO Doc default template bodies — used only in Add Agency (create), not when editing. */
export const AGENCY_TEMPLATE_DEFAULT_EMAIL_BODIES = {
  phTemplate: `Hello,
Welcome to [Agency Name]. Attached is your Patient Handbook, which contains important information about our services, patient rights, and what to expect during your care.
Please review this document for reference throughout your care with our agency.
If you have any questions, please contact us directly.
Thank you,
[Agency Name]`,
  piTemplate: `Hello,
Attached is your Patient Information Report, which reflects updates to your care plan and current patient information on file with our agency.
Please review the document and contact us if you have any questions regarding the information provided.
Thank you,
[Agency Name]`,
  otherTemplate: `Hello,
Attached are documents related to your care with [Agency Name]. These may include instructions, billing information, or additional materials provided for your reference.
Please review the attached files and contact us if you have any questions.
Thank you,
[Agency Name]`,
  esignTemplate: `Hello,
You have been requested to review and sign a patient document for [Agency Name].
Please click on the link below to review, verify patient details, and sign the document:
[URL]

Thank you,
[Agency Name]`,
  hosAddendumTemplate: `Hello,
You have received the Hospice Non-Covered Items, Services, and Drugs Notification (HOS Addendum) from [Agency Name].
Please click on the link below to review, verify details, and complete your signature:
[URL]

Thank you,
[Agency Name]`,
  hosAddendumOverdueTemplate: `URGENT NOTICE:
The Hospice Non-Covered Items, Services, and Drugs Notification (HOS Addendum) from [Agency Name] is now overdue for signature.
Please click on the link below to immediately review and complete your signature:
[URL]

Thank you,
[Agency Name]`,
};

export const AGENCY_TEMPLATE_DEFAULT_SMS = {
  phTemplate:
    "Hello, this is [Agency Name]. Your Patient Handbook is available for review. It contains important information about your care and patient rights. Please check the link sent to view your documents.",
  piTemplate:
    "Hello, this is [Agency Name]. Your Patient Information Report has been updated with details about your care plan. Please review the document using the link provided.",
  otherTemplate:
    "Hello, this is [Agency Name]. We have sent you additional documents related to your care. Please review them using the link provided and contact us if you have any questions.",
  esignTemplate:
    "Hello, this is [Agency Name]. You have been requested to review and sign a document. Please check the link sent to sign your documents.",
  hosAddendumTemplate:
    "Hello, this is [Agency Name]. Please review and sign your Hospice Addendum (Non-Covered Items, Services, and Drugs) using the link sent.",
  hosAddendumOverdueTemplate:
    "[URGENT] [Agency Name]: Your HOS Addendum is overdue for signature. Please review and sign immediately using the link sent.",
};

export const TEMPLATE_INFO = {
  piTemplate: {
    label: 'PIR Template',
    description: 'Report from HCHB reflecting updates to the patient\'s care plan',
    emailExample: 'e.g. Hello {clientName}, we hope your recent appointment went well. Please let us know if you have any feedback or need further assistance.',
    smsExample: 'e.g. Hello {clientName}, your PIR report is ready. Please contact us if you have any questions.',
  },
  phTemplate: {
    label: 'Patient Handbook Template',
    description: 'SOC documents required for patients at Start of Care',
    emailExample: 'e.g. Hello {clientName}, this is a reminder for your appointment on {appointmentDate}. Please contact us if you have any questions.',
    smsExample: 'e.g. Hello {clientName}, this is a reminder for your appointment on {appointmentDate}. Please contact us if you have any questions.',
  },
  otherTemplate: {
    label: 'Other Documents Template',
    description: 'Additional documents such as instructions or billing info the agency may wish to send to the patient',
    emailExample: 'e.g. Hello {clientName}, this is a general message from our agency. Please contact us if you have any questions or need assistance.',
    smsExample: 'e.g. Hello {clientName}, this is a general message from our agency. Please contact us if you have any questions.',
  },
  esignTemplate: {
    label: 'Patient Document Template',
    description: 'Custom email template used when sending a patient document to a clinician for E-Sign',
    emailExample: 'e.g. Hello, you have been requested to sign a document. Please click [URL] to sign.',
    smsExample: 'e.g. Hello, you have been requested to sign a document. Please click the link to sign.',
  },
  hosAddendumTemplate: {
    label: 'HOS Addendum Template',
    description: 'Notification sent to beneficiary/representative for Hospice Non-Covered Items, Services, and Drugs',
    emailExample: 'e.g. Hello, you have received the Hospice Addendum from [Agency Name]. Please click [URL] to sign.',
    smsExample: 'e.g. Hello, please review and sign your Hospice Addendum via the link sent.',
  },
  hosAddendumOverdueTemplate: {
    label: 'HOS Addendum Overdue Template',
    description: 'Urgent escalation notice sent when the HOS Addendum remains unsigned after the clock expiration',
    emailExample: 'e.g. [URGENT] Action required: Your HOS Addendum is overdue. Please sign at [URL].',
    smsExample: 'e.g. [URGENT] Action required: Your HOS Addendum is overdue. Please sign via the link.',
  },
};

export const PDFJS_WORKER_URL = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.min.js';

